import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "monthlyToggle",
    "yearlyToggle",
    "monthlyPlan",
    "yearlyPlan",
  ];

  connect() {
    this.initializeTransitions();
    this.setupEventListeners();
  }

  initializeTransitions() {
    if (this.hasMonthlyPlanTarget && this.hasYearlyPlanTarget) {
      this.monthlyPlanTarget.style.transition =
        "opacity 0.3s ease-in-out, transform 0.3s ease-in-out";
      this.yearlyPlanTarget.style.transition =
        "opacity 0.3s ease-in-out, transform 0.3s ease-in-out";
    }
  }

  setupEventListeners() {
    if (this.hasMonthlyToggleTarget) {
      this.monthlyToggleTarget.addEventListener(
        "change",
        this.handleMonthlyToggle.bind(this),
      );
    }

    if (this.hasYearlyToggleTarget) {
      this.yearlyToggleTarget.addEventListener(
        "change",
        this.handleYearlyToggle.bind(this),
      );
    }
  }

  handleMonthlyToggle(event) {
    if (event.target.checked) {
      this.fadeOutYearlyThenFadeInMonthly();
    }
  }

  handleYearlyToggle(event) {
    if (event.target.checked) {
      this.fadeOutMonthlyThenFadeInYearly();
    }
  }

  // Helper to wait for transition end
  waitForTransitionEnd(element) {
    return new Promise((resolve) => {
      const handler = (event) => {
        // Only resolve for opacity or transform transitions
        if (
          event.propertyName === "opacity" ||
          event.propertyName === "transform"
        ) {
          element.removeEventListener("transitionend", handler);
          resolve();
        }
      };
      element.addEventListener("transitionend", handler);
    });
  }

  async fadeOutYearlyThenFadeInMonthly() {
    this.yearlyPlanTarget.style.opacity = "0";
    this.yearlyPlanTarget.style.transform = "translateY(20px)";
    await this.waitForTransitionEnd(this.yearlyPlanTarget);
    this.yearlyPlanTarget.classList.add("d-none");
    this.monthlyPlanTarget.classList.remove("d-none");
    this.monthlyPlanTarget.style.opacity = "0";
    this.monthlyPlanTarget.style.transform = "translateY(20px)";
    // Force reflow to ensure transition
    void this.monthlyPlanTarget.offsetWidth;
    this.monthlyPlanTarget.style.opacity = "1";
    this.monthlyPlanTarget.style.transform = "translateY(0)";
  }

  async fadeOutMonthlyThenFadeInYearly() {
    this.monthlyPlanTarget.style.opacity = "0";
    this.monthlyPlanTarget.style.transform = "translateY(20px)";
    await this.waitForTransitionEnd(this.monthlyPlanTarget);
    this.monthlyPlanTarget.classList.add("d-none");
    this.yearlyPlanTarget.classList.remove("d-none");
    this.yearlyPlanTarget.style.opacity = "0";
    this.yearlyPlanTarget.style.transform = "translateY(20px)";
    // Force reflow to ensure transition
    void this.yearlyPlanTarget.offsetWidth;
    this.yearlyPlanTarget.style.opacity = "1";
    this.yearlyPlanTarget.style.transform = "translateY(0)";
  }
}
